import React from 'react';
import {motion} from 'framer-motion';

const FinalCTA=({timeLeft,formatTime,openCheckoutPopup})=> {
  return (
    <section className="py-16 bg-gradient-to-br from-red-600 to-orange-600 text-white">
      <div className="container mx-auto px-4">
        <motion.div 
          className="text-center"
          initial={{opacity: 0, y: 30}}
          whileInView={{opacity: 1, y: 0}}
          transition={{duration: 0.6}}
          viewport={{once: true}}
        >
          <h2 className="text-3xl md:text-5xl font-bold mb-4">
            Last Chance to Unlock <span className="text-yellow-300">24 Ways for ₹97</span>
            🕛
          </h2>
          <p className="text-xl mb-8 opacity-90">
            Timer resets only once. Bonuses vanish when it ends.
          </p>
          
          <div className="timer-glow bg-black/30 text-white px-8 py-4 rounded-2xl inline-flex items-center space-x-3 mb-8">
            <span className="text-2xl">⏰</span>
            <span className="font-bold text-3xl">{formatTime(timeLeft)}</span>
          </div>

          <motion.button
            onClick={openCheckoutPopup}
            className="bg-white text-red-600 px-12 py-6 rounded-2xl font-bold text-2xl hover:bg-gray-100 transition-colors shadow-2xl"
            whileHover={{scale: 1.05}}
            whileTap={{scale: 0.95}}
          >
            💥 Get the eBook Now Before Offer Ends →
          </motion.button>

          <p className="text-sm mt-6 opacity-75">
            Don't let this opportunity slip away. Your future self will thank you.
          </p>
        </motion.div>
      </div>
    </section>
  );
};

export default FinalCTA;